import { useCallback, useMemo } from 'react';
import {
  StorageDashboardSection,
  type DashboardCardWidth
} from '@jarvis/platform-ui/storage-dashboard';
import { useHasRole } from '../../auth/useHasRole';
import { useAuthStore } from '../../auth/useAuthStore';
import { apiFetch } from '../../api/client';
import { CalculatorWidget } from '../Apps/Utilities/CalculatorWidget';
import { MY_APPS_SHORTCUTS_CARD_ID, MyAppsShortcutsCard } from './MyAppsShortcutsCard';

const CALCULATOR_CARD_ID = 'calculator';

export function DashboardPage() {
  const { hasAssistantRole } = useHasRole();
  const username = useAuthStore((s) => s.username);
  const canSeeStorageDashboard = hasAssistantRole('AssistantUser');

  const additionalCards = useMemo(
    () => [
      { id: MY_APPS_SHORTCUTS_CARD_ID, title: 'My Apps' },
      { id: CALCULATOR_CARD_ID, title: 'Calculator' }
    ],
    []
  );

  const getAllowedWidths = useCallback((id: string): readonly DashboardCardWidth[] | undefined => {
    if (id === CALCULATOR_CARD_ID || id === MY_APPS_SHORTCUTS_CARD_ID) return [1];
    return undefined;
  }, []);

  const renderAdditionalCard = useCallback((id: string) => {
    if (id === CALCULATOR_CARD_ID) return <CalculatorWidget />;
    if (id === MY_APPS_SHORTCUTS_CARD_ID) return <MyAppsShortcutsCard />;
    return null;
  }, []);

  return (
    <div className="ops-page">
      {!canSeeStorageDashboard ? (
        <>
          <div className="dashboard-header">
            <div>
              <h2 className="dashboard-title">Dashboard</h2>
              <p className="dashboard-subtitle">
                Your JARVIS Assistant snapshot for the areas you can access.
              </p>
            </div>
          </div>
          <section className="dashboard-card dashboard-card--welcome">
            <h3 className="dashboard-card__title">Welcome</h3>
            <p>
              You&apos;re signed in to JARVIS IT Assistant. Dashboard cards will appear here as
              modules are added for your role.
            </p>
          </section>
          <CalculatorWidget />
        </>
      ) : (
        <StorageDashboardSection
          enabled={canSeeStorageDashboard}
          username={username}
          storageKeyPrefix="jarvis-assistant-dashboard-layout"
          apiFetch={apiFetch}
          openHref="/files"
          openLabel="Open Files"
          accessTitle="Your Storage"
          accessSubtitle="File mounts you can access"
          additionalCards={additionalCards}
          renderAdditionalCard={renderAdditionalCard}
          getAllowedWidths={getAllowedWidths}
          pageHeader={
            <div>
              <h2 className="dashboard-title">Dashboard</h2>
              <p className="dashboard-subtitle">
                Your JARVIS Assistant snapshot for the areas you can access.
              </p>
            </div>
          }
        />
      )}
    </div>
  );
}
